import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode()
const _hoisted_4 = /*#__PURE__*/_createTextVNode()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
    return (_openBlock(), _createElementBlock(_Fragment, {
      key: item.id
    }, [
      (this.isOrganisationTarget(item))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(item.organisationName) + " (" + _toDisplayString(item.personGivenName) + " " + _toDisplayString(item.personSurName) + ")", 1))
        : _createCommentVNode("", true),
      (this.isReviewCycleTarget(item))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("plot.template.list.ofNode")), 1),
            _hoisted_3,
            _createElementVNode("span", null, [
              _createElementVNode("b", null, _toDisplayString(item.reviewCycleNodeName), 1)
            ]),
            _hoisted_4,
            _createElementVNode("span", null, "(" + _toDisplayString(item.reviewCycleName) + ")", 1)
          ]))
        : _createCommentVNode("", true)
    ], 64))
  }), 128))
}